import request from '@services/request';

const cashierApi = '/cashiers';
const deactivateCashierApi = '/cashiers/deactivateCashier';
const employeesApi = '/employees';

const getCashiersWithSubsidiaryRecords = async () => {
  const result = await request.get(`/api/v1/corresponsal${cashierApi}`);
  const { data } = result;
  return data;
};

const inactiveCashierService = async (cashierId, subsidiaryId) => {
  const body = {
    subsidiary_id: subsidiaryId,
    profile_id: cashierId,
  };
  const result = await request.post(`/api/v1/corresponsal${deactivateCashierApi}`, body);
  const { data } = result;
  return data;
};

const getCashiers = async (params = {}) => {
  const result = await request.get(`/api/v1/corresponsal${employeesApi}`, params);
  const { data } = result;
  return data;
};

const activateCashier = async (subsidiaryId, profileId) => {
  const body = {
    subsidiary_id: subsidiaryId,
    profile_id: profileId,
  };
  const result = await request.post(`/api/v1/corresponsal${cashierApi}`, body);
  const { data } = result;
  return data;
};

export {
  getCashiersWithSubsidiaryRecords,
  inactiveCashierService,
  getCashiers,
  activateCashier,
};
